module.exports = __webpack_public_path__ + "img/202.5e376734.png";